import {
  SET_PIN_ACCEPTED,
  SET_PIN,
  CLEAR_PIN,
} from '../../constants'

const initState = {
  encodedPin: null,
}

export default function PinAcceptanceReducer(
  state = initState,
  {
    type,
    path,
    encodedPin,
    pin,
  } = {}
) {
  switch (type) {
    case SET_PIN: {
      return {
        ...state,
        encodedPin,
      }
    }
    case CLEAR_PIN: {
      return {
        ...state,
        pin,
      }
    }
    case SET_PIN_ACCEPTED: {
      return {
        ...state,
        [path]: { pinAccepted: true },
      }
    }

    default:
      return state
  }
}
